export const STEP_SETUP = 'setup';
export const STEP_RECIPIENTS_MANUAL = 'recipients_manual';
export const STEP_REVIEW = 'review';
